module.exports = __webpack_public_path__ + "img/chs.389eda32.jpg";